<template>
    <div class="page-blog">
        <!--banner-->
        <div class="banner">
            <div class="container">
                <h2 class="timeline">博客</h2>
            </div>
        </div>
        <!--banner-->

        <div class="blog">
            <div class="container">
                <div class="blog-head">
                    <div class="col-md-4 blog-top" v-for="g in gameData" v-if="pagesize && g.status!=0">
                        <div class="blog-in">
                            <a :href="'static/article/'+g.path+'.html'" :title="g.title" target="_blank">
                              <el-image class="img-responsive" :src="'static/images/blog/'+g.path+'.jpg'" alt=" ">
                                <div slot="placeholder" class="img-placeholder">
                                  图片加载中<span class="dot">...</span>
                                </div>
                              </el-image>
                            <div class="blog-grid">
                                <h4>{{g.title}}</h4>
<!--                                <p></p>-->
                                <div class="date">
                                    <span class="date-in" title="发布日期"><i class="glyphicon glyphicon-calendar"> </i>{{g.date}}</span>
                                    <span class="date-in" title="最后更新日期" v-if="g.update"><i class="glyphicon glyphicon-refresh"> </i>{{g.update}}</span>
                                    <div class="clearfix"> </div>
                                </div>
<!--                                <div class="more-top">-->
<!--                                    <a class=" hvr-wobble-top" :href="'static/article/'+g.path+'.html'" :title="g.title" target="_blank">查看详情</a>-->
<!--                                </div>-->
                            </div>
                            </a>
                        </div>
                    </div>
                    <div class="clearfix"> </div>
                </div>
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[15, 30, 60, 90]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Demo',
  components: {},
  data() {
    return {
      gameList: [],
      total: 0,
      currentPage: 1, // 默认显示第1页
      pagesize: 15 // 默认一次显示10条数据
    }
  },
  created() {
    this.getData()
  },
  mounted() {},
  computed: {
    gameData: function() {
      return this.gameList.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
    }
  },
  methods: {
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/blog.json' + '?' + timeStamp).then(game => {
        for (var i = 0; i < game.data.length; i++) {
          if (game.data[i].status === 1) {
            this.gameList.push(game.data[i])
            this.total = this.gameList.length
            //                            console.log(this.gameList[0])
          }
        }
      })
    },
    handleSizeChange(size) {
      this.pagesize = size
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Blog.vue